export const CustomerTypes = [
  { key: "real", value: "حقیقی" },
  { key: "legal", value: "حقوقی" },
];
